import React from 'react';
import styled from 'styled-components';
import Title from '../shared/Title';
import { Element, scroller } from 'react-scroll';
import { flexColumn, palette, breakpoints } from '../../constants/styles';
import { space, layout, flex } from 'styled-system';

const StyledTableOfContents = styled(Element)`
  padding: 20px 20px 20px 20px;
`;

const StyledChapter = styled.div`
  border: 1px solid gray;
  padding: 20px;
  background-color: white;
  ${space}
  ${layout}
  transition: background-color 0.1s ease-in-out;
  &:active {
    background-color: ${palette.terciaryColor}22;
    transition: background-color 0.1s ease-in-out;
  }
  cursor: pointer;

  ${breakpoints.tablet} {
    margin-right: 20px;
  }
`;

const ChaptersContainer = styled.div`
  ${flexColumn}
  ${space}
  ${flex}
  ${breakpoints.tablet} {
    flex-direction: row;
  }
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

const ChapterTitle = styled.span`
  font-family: 'proxima-nova', Helvetica Neue, Arial, sans-serif;
  font-size: 30px;
  color: ${palette.terciaryColor};
  font-weight: 500;
  line-height: 1.25em;
  margin-top: 15px;
  display: block;
`;

const ChapterName = styled.span`
  font-family: Merriweather, Georgia, serif;
  font-size: 18px;
  color: #666;
  display: block;
  font-weight: bold;
`;

export default function TableOfContents({ chapters }) {
  return (
    <StyledTableOfContents>
      <Title level={2} align="center">
        Tabla de contenido
      </Title>
      <ChaptersContainer mt={['20px']}>
        {chapters.map((chapter) => (
          <StyledChapter
            onClick={() => {
              window.setTimeout(function() {
                scroller.scrollTo(chapter.id);
              }, 100);
            }}
            mb={['20px']}
            width={['250px', '320px']}
            height={['110px', '120px']}
          >
            <ChapterName>{chapter.name}</ChapterName>
            <ChapterTitle>{chapter.title}</ChapterTitle>
          </StyledChapter>
        ))}
      </ChaptersContainer>
    </StyledTableOfContents>
  );
}
